// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/public/settingIcon.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.storagesView_container__CIFA3 {
    width: 85%;
    padding: 30px;
    margin-left: auto;
    text-align: left;
}


.storagesView_toggle__w0bWt {
  position: relative;
  display: inline-block;
  width: 50px;
  height: 26px;
}

.storagesView_toggle__w0bWt input {
  opacity: 0;
  width: 0;
  height: 0;
}

.storagesView_slider__ASlJo {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: all 0.3s ease;
  border-radius: 26px;
  box-shadow: inset 0 0 3px rgba(0, 0, 0, 0.2);
}

.storagesView_slider__ASlJo:before {
  position: absolute;
  content: "";
  height: 20px;
  width: 20px;
  left: 3px;
  bottom: 3px;
  background-color: white;
  transition: all 0.3s ease;
  border-radius: 50%;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
}

.storagesView_toggle__w0bWt input:checked + .storagesView_slider__ASlJo {
  background-color: rgba(29, 135, 82, 1);
  box-shadow: 0 0 4px rgba(29, 135, 82, 0.5);
}

.storagesView_toggle__w0bWt input:checked + .storagesView_slider__ASlJo:before {
  transform: translateX(24px);
}

.storagesView_headerText__S9cH2 {
    font-size: 15px;
    width: 55px;
    color: rgba(29, 135, 82, 1);
    padding: 10px 16px;
    border-bottom: 2px solid rgba(29, 135, 82, 1);
    margin-bottom: 25px;
}

.storagesView_table__hEEcq {
    width: 80vw;
    border-collapse: collapse;
  background: white;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 6px rgba(0,0,0,0.05);
}
.storagesView_table__hEEcq th,
.storagesView_table__hEEcq td {
  padding: 12px 16px;
  border-bottom: 1px solid #e0e0e0;
  text-align: left;
  font-size: 14px;
}

.storagesView_table__hEEcq th {
  background-color: #f9f9f9;
  font-weight: 600;
  color: #333;
}

.storagesView_table__hEEcq tr:hover {
  background-color: #f5f5f5;
}

.storagesView_settingIcon__nWk4g {
  display: block;
  width: 20px;
  height: 20px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: contain;
  background-repeat: no-repeat;
}

.storagesView_optionsButton__lkT1e {
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.storagesView_dots__tafo3 {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-left: 7px;
}

.storagesView_dot__dPugY {
  width: 4px;
  height: 4px;
  background-color: #666;
  border-radius: 50%;
}

.storagesView_addCustomers__l4H8V {
  position: absolute;
  top: 2rem;
  right: 3.5rem;
  background: rgba(29, 135, 82, 1);
  color: white;
  padding: 5px 20px;
  border-radius: 5px;
  font-size: 25px;
}

.storagesView_deleteButton__nocXg {
  background: none;
  border: none;
  cursor: pointer;
  color: #e53935;
  display: flex;
  align-items: center;
  justify-content: center;
}

.storagesView_deleteButton__nocXg:hover {
  color: #b71c1c;
}
`, "",{"version":3,"sources":["webpack://./src/styles/storagesView.module.css"],"names":[],"mappings":"AAAA;IACI,UAAU;IACV,aAAa;IACb,iBAAiB;IACjB,gBAAgB;AACpB;;;AAGA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,sCAAsC;EACtC,0CAA0C;AAC5C;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;IACI,eAAe;IACf,WAAW;IACX,2BAA2B;IAC3B,kBAAkB;IAClB,6CAA6C;IAC7C,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,yBAAyB;EAC3B,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,sCAAsC;AACxC;AACA;;EAEE,kBAAkB;EAClB,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,yDAA8C;EAC9C,wBAAwB;EACxB,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,aAAa;EACb,gCAAgC;EAChC,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB","sourcesContent":[".container {\n    width: 85%;\n    padding: 30px;\n    margin-left: auto;\n    text-align: left;\n}\n\n\n.toggle {\n  position: relative;\n  display: inline-block;\n  width: 50px;\n  height: 26px;\n}\n\n.toggle input {\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n.slider {\n  position: absolute;\n  cursor: pointer;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: #ccc;\n  transition: all 0.3s ease;\n  border-radius: 26px;\n  box-shadow: inset 0 0 3px rgba(0, 0, 0, 0.2);\n}\n\n.slider:before {\n  position: absolute;\n  content: \"\";\n  height: 20px;\n  width: 20px;\n  left: 3px;\n  bottom: 3px;\n  background-color: white;\n  transition: all 0.3s ease;\n  border-radius: 50%;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);\n}\n\n.toggle input:checked + .slider {\n  background-color: rgba(29, 135, 82, 1);\n  box-shadow: 0 0 4px rgba(29, 135, 82, 0.5);\n}\n\n.toggle input:checked + .slider:before {\n  transform: translateX(24px);\n}\n\n.headerText {\n    font-size: 15px;\n    width: 55px;\n    color: rgba(29, 135, 82, 1);\n    padding: 10px 16px;\n    border-bottom: 2px solid rgba(29, 135, 82, 1);\n    margin-bottom: 25px;\n}\n\n.table {\n    width: 80vw;\n    border-collapse: collapse;\n  background: white;\n  border-radius: 8px;\n  overflow: hidden;\n  box-shadow: 0 2px 6px rgba(0,0,0,0.05);\n}\n.table th,\n.table td {\n  padding: 12px 16px;\n  border-bottom: 1px solid #e0e0e0;\n  text-align: left;\n  font-size: 14px;\n}\n\n.table th {\n  background-color: #f9f9f9;\n  font-weight: 600;\n  color: #333;\n}\n\n.table tr:hover {\n  background-color: #f5f5f5;\n}\n\n.settingIcon {\n  display: block;\n  width: 20px;\n  height: 20px;\n  background-image: url(/public/settingIcon.png);\n  background-size: contain;\n  background-repeat: no-repeat;\n}\n\n.optionsButton {\n  background: none;\n  border: none;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.dots {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  margin-left: 7px;\n}\n\n.dot {\n  width: 4px;\n  height: 4px;\n  background-color: #666;\n  border-radius: 50%;\n}\n\n.addCustomers {\n  position: absolute;\n  top: 2rem;\n  right: 3.5rem;\n  background: rgba(29, 135, 82, 1);\n  color: white;\n  padding: 5px 20px;\n  border-radius: 5px;\n  font-size: 25px;\n}\n\n.deleteButton {\n  background: none;\n  border: none;\n  cursor: pointer;\n  color: #e53935;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.deleteButton:hover {\n  color: #b71c1c;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `storagesView_container__CIFA3`,
	"toggle": `storagesView_toggle__w0bWt`,
	"slider": `storagesView_slider__ASlJo`,
	"headerText": `storagesView_headerText__S9cH2`,
	"table": `storagesView_table__hEEcq`,
	"settingIcon": `storagesView_settingIcon__nWk4g`,
	"optionsButton": `storagesView_optionsButton__lkT1e`,
	"dots": `storagesView_dots__tafo3`,
	"dot": `storagesView_dot__dPugY`,
	"addCustomers": `storagesView_addCustomers__l4H8V`,
	"deleteButton": `storagesView_deleteButton__nocXg`
};
export default ___CSS_LOADER_EXPORT___;
